<template>
  <div :class="darkTheme ? 'sidebarDark' : 'sidebar'">
    <v-expansion-panel v-if="!mini" class="kaProfile" expand v-model="panel" focusable>
      <v-expansion-panel-content
        v-for="(item, key) in resultListV2"
        :key="key"
        expand-icon="chevron_right"
      >
        <template v-slot:header>
          <div v-if="item.length > 0" class="subheading font-weight-bold">
            {{ localeSuffix === '_vi_vn' ? item[0].group_vn : item[0].group_en }}
          </div>
        </template>
        <v-list class="kaProfile-list">
          <v-list-tile
            :class="{ active: menu.active }"
            :name="menu.name"
            :color="menu.active ? menu.color : ''"
            class="menu-item"
            v-bind:href="menu.route"
            style="border-radius: 6px"
            v-for="menu in item"
            :key="menu.id"
            :style="{ cursor: 'pointer', backgroundColor: menu.active ? '#E6E9EC' : 'transparent' }"
            @click.prevent="changeNavicationRouteItem($event, menu)"
          >
            <div class="menu-item__content">
              <v-icon
                :class="menu.iconClass"
                class="icon-item"
                :style="{ fontWeight: 600 }"
                :color="menu.active ? menu.color : ''"
                >{{ menu.icon }}</v-icon
              >
              <v-list-tile-content class="content__menu-item">
                <v-list-tile-title
                  :style="{
                    fontWeight: 600,
                    lineHeight: '22px',

                    color: menu.active ? menu.color : ''
                  }"
                >
                  {{
                    localeSuffix === '_vi_vn'
                      ? menu.name_vn || menu.name
                      : menu.name_en || menu.name
                  }}
                </v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action> </v-list-tile-action>
            </div>
          </v-list-tile>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SidebarV2',
  props: {
    resultListV2: {
      type: Array
    },
    onChangeRoute: {
      type: Function
    },
    panel: {
      type: Array
    },

    mini: {
      type: Boolean
    }
  },
  data() {
    return {}
  },
  methods: {
    changeNavicationRouteItem($event, item) {
      this.$emit('onChangeRoute', $event, item)
    },
    changeNavicationMini() {
      if (this.isMobile) {
        this.$store.dispatch('setNavigationDrawer', null)
      } else {
        const value = !this.navigationMini
        this.$store.dispatch('setNavigationMini', value)
      }
    }
  },
  computed: {
    darkTheme() {
      const theme = this.$store.getters.theme
      if (!theme) return false
      return theme
    },
    menuStyle() {
      if (this.darkTheme) {
        return {
          background: 'rgba(105, 112, 119, 0.17)'
        }
      }
      return {
        backgroundColor: '#E6E9EC'
      }
    },
    navigationDrawerStyle() {
      if (this.isMobile) {
        return {
          color: 'white',
          dark: false
        }
      }

      return {
        color: 'primary',
        dark: true
      }
    },
    profile: {
      cache: false,
      get() {
        return this.$store.getters.userProfile
      }
    },
    ...mapGetters(['localeSuffix'])
  }
}
</script>

<style lang="scss" scoped>
.icon-item {
  font-weight: 600;
}

.sidebar {
  height: inherit;
  overflow-y: auto;
  overflow-x: hidden;

  .kaProfile {
    padding: 0 16px 48px 16px;
    box-shadow: none;

    .v-expansion-panel__container {
      //padding: 0px 12px;
      background-color: transparent;
      // margin: 0 !important;
      //border-top: none !important;

      .v-expansion-panel__header {
        .subheading {
          //margin-left: -2px;
          text-transform: uppercase;
          font-size: 14px !important;
          line-height: 16px;
        }

        .icon-expand {
          // margin-right: -12px !important;
          transform: rotate(-90deg);

          &.rotated {
            //margin-right: -12px !important;
            transform: rotate(45deg);
          }
        }
      }

      .v-expansion-panel__body {
        //margin-left: -5px;
        .v-list {
          border-radius: 6px;

          .active {
            cursor: pointer;
            border-radius: 6px;
            background: hsla(0, 0%, 100%, 0.08);

            a {
              cursor: pointer !important;
            }
          }

          .menu-item {
            border-radius: 6px;
            cursor: pointer;

            .custom-link {
              color: #fff;
              text-decoration: none;
            }

            .v-list__tile {
              .menu-item__content {
                margin: 0 0;
                display: flex;
                gap: 16px;
                font-weight: 600;

                .content__menu-item {
                  font-weight: 600;
                  margin-left: 0 !important;
                }
              }
            }
          }
        }
      }
    }
  }
}

.sidebarDark {
  height: inherit;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #000;
    border-radius: 6px;
    border: 1px solid #ccc;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #cccc; /* Màu khi hover lên nút cuộn */
  }

  &::-webkit-scrollbar-track {
    background-color: transparent; /* Màu của thanh cuộn */
  }

  .kaProfile {
    padding: 0 16px 48px 16px;
    box-shadow: none;

    .v-expansion-panel__container {
      //padding: 0px 12px;
      background-color: transparent;
      // margin: 0 !important;
      //border-top: none !important;

      .v-expansion-panel__header {
        .subheading {
          //margin-left: -2px;
          text-transform: uppercase;
          font-size: 14px !important;
          line-height: 16px;
        }

        .icon-expand {
          // margin-right: -12px !important;
          transform: rotate(-90deg);

          &.rotated {
            //margin-right: -12px !important;
            transform: rotate(45deg);
          }
        }
      }

      .v-expansion-panel__body {
        //margin-left: -5px;
        .v-list {
          border-radius: 6px;

          .active {
            cursor: pointer;
            border-radius: 6px;
            background: hsla(0, 0%, 100%, 0.08);

            a {
              cursor: pointer !important;
            }
          }

          .menu-item {
            border-radius: 6px;
            cursor: pointer;

            .custom-link {
              color: #fff;
              text-decoration: none;
            }

            .v-list__tile {
              .menu-item__content {
                margin: 0 0;
                display: flex;
                gap: 16px;
                font-weight: 600;

                .content__menu-item {
                  font-weight: 600;
                  margin-left: 0 !important;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.v-expansion-panel {
  //gap: 10px;
}

.v-expansion-panel__container--active {
  > .v-expansion-panel__header {
    .v-expansion-panel__header__icon {
      //margin-right: -12px;
      .v-icon {
        transform: rotate(90deg);
      }
    }
  }
}

.v-expansion-panel__container {
  .v-expansion-panel__header {
    .v-expansion-panel__header__icon {
      //margin-right: -12px;
      .v-icon {
        //transform: rotate(45deg);
      }
    }

    padding: 12px 0 !important;

    //&:hover {
    //background: hsla(0, 0%, 45%, 0.08);
    //}
  }

  .v-expansion-panel__body {
    padding-bottom: 10px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    .kaProfile-list {
      display: flex;
      flex-direction: column;
    }

    .v-list {
      padding: 0 0;

      .menu-item {
        border-radius: 6px;

        .v-list__tile {
          border-radius: 6px !important;
          padding: 10px 8px !important;
        }

        &:hover {
          border-radius: 6px;
          background: rgba(255, 255, 255, 0.15);
        }
      }
    }
  }
}
</style>
